import React from "react";

export default function DateSeparator({ date }) {
  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString("uk-UA", {
      day: "numeric",
      month: "long",
    });
  };

  return (
      <div className="message-date">
        <div className="date">{formatDate(date)}</div>
      </div>
  )
}